import Button from "componentsv2/button/Button";
import HorizontalDivider from "componentsv2/widgets/HorizontalDivider";

const BASE_BTN_SIZE = "w-full sm:w-1/2 md:w-1/3 md:max-w-[300px]";

function FooterForm({ onSave, layout, onChangeView, onClose, recordId, closeOnChangeView }) {
  const { form_action } = layout;
  const buttonsActive = [];

  let mode = "edit";
  if (recordId > 0) {
    mode = "create";
  }

  const btnAccept = (
    <Button
      key="accept"
      color="blue"
      size={BASE_BTN_SIZE}
      onClick={() => onSave("accept", "modal")}
      content="basic_modal.button_ok"
    />
  );

  const btnCreate = (
    <Button
      key="create"
      color="blue"
      size={BASE_BTN_SIZE}
      onClick={() => onSave("create")}
      content="basic_modal.button_create"
    />
  );

  const btnAdd = (
    <Button
      key="add"
      color="blue"
      size={BASE_BTN_SIZE}
      onClick={() => onSave("add")}
      content="basic_modal.button_add"
    />
  );

  if (closeOnChangeView && onChangeView) {
    buttonsActive.push(
      <Button
        key="close"
        color="black"
        size={BASE_BTN_SIZE}
        onClick={() => onChangeView("return")}
        content="basic_modal.button_close"
      />,
    );
  } else if (onClose) {
    buttonsActive.push(
      <Button
        key="close"
        color="black"
        size={BASE_BTN_SIZE}
        onClick={onClose}
        content="basic_modal.button_close"
      />,
    );
  }
  if (form_action) {
    const editAction = form_action.includes("edit");
    const addAction = form_action.includes("add");
    const createAction = form_action.includes("create");
    if (editAction && mode === "edit") {
      buttonsActive.push(btnAccept);
    } else if (addAction && mode === "add") {
      buttonsActive.push(btnAdd);
    } else if (createAction && mode === "create") {
      buttonsActive.push(btnCreate);
    }
  }

  return (
    <div className="h-fit bottom-0 mt-auto mb-0 pb-3 sticky w-full bg-gray-100">
      <HorizontalDivider index="hd-footer-form" />
      <div id="bottom-form" className="flex justify-end pt-1 w-auto gap-x-3">
        {buttonsActive}
      </div>
    </div>
  );
}

export default FooterForm;
